export enum ComputedNormality {
  MISSING = 'Missing',
  FAILED = 'Failed',
  NORMAL = 'Normal',
  ABNORMAL = 'Abnormal',
}

export enum PhysicianOversight {
  REQUIRED = 'Required',
  NOT_REQUIRED = 'NotRequired',
  WITH_PHYSICIAN = 'WithPhysician',
  FINAL_REVIEW = 'FinalReview',
  COMPLETED_PHYSICIAN = 'CompletedPhysician',
}

export enum PhysicianNormality {
  NORMAL = 'Normal',
  ABNORMAL = 'Abnormal',
  CRITICAL = 'Critical',
  EMPTY = '',
}

export enum GlobalNormality {
  NORMAL = 'Normal',
  ABNORMAL = 'Abnormal',
  CRITICAL = 'Critical',
  INVALID = 'Invalid',
}

export enum Validity {
  VALID = 'Valid',
  MISSING_VALUES = 'MissingValues',
  FAILED_VALUES = 'FailedValues',
  MISSING_FAILED_VALUES = 'MissingAndFailedValues',
  NO_VALUES = 'NoValues',
}

export enum LabResultStatus {
  COMPLETED = 'Completed',
  PROCESSING = 'Processing',
  FAILED = 'Failed',
}